import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import chroma from 'chroma-js';
import theme from 'utils/theme';
import { getReadableColor } from 'utils/colors';
import IconLoader from 'components/IconLoader';

const getBackground = props => {
  return chroma(props.color)
    .luminance(props.luminance)
    .hex();
};

const getColors = props => {
  const background = getBackground(props);
  const color = getReadableColor({ color: background, black: '#413f40' });

  return css`
    background: ${background};
    color: ${color};
  `;
};

const getIconColor = props => {
  return chroma(props.color)
    .luminance(0.5)
    .hex();
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  font-size: 1em;
  line-height: 1.2;
  font-weight: ${props => props.theme.fontWeights.light};
  ${props => getColors(props)};
  border-radius: 8px;
`;

const Icon = styled.div`
  display: flex;
  font-size: 1.5em;
  color: ${getIconColor};
`;

const AlertBase = props => {
  const { className, icon, color, luminance, style, children } = props;
  return (
    <Wrapper className={className} style={style} color={color} luminance={luminance}>
      {icon && (
        <Icon color={color}>
          <IconLoader name={icon} />
        </Icon>
      )}
      <span>{children}</span>
    </Wrapper>
  );
};

AlertBase.propTypes = {
  children: PropTypes.any.isRequired,
  color: PropTypes.string,
  icon: PropTypes.string,
  luminance: PropTypes.number,
  style: PropTypes.object,
};

AlertBase.defaultProps = {
  color: theme.colors.error,
  luminance: 0.8,
};

export default AlertBase;
